import { hexIdToHumanHexId } from "@hex/common";
import { useCallback } from "react";
import { useHistory } from "react-router";

import { useCreateExploreMutation } from "../../explore/createExploreMutation.generated.js";
import { ORG_ID } from "../../orgs";
import { ExploreRouteParams, Routes } from "../../route/routes";
import { DEFAULT_PROJECT_TITLE } from "../logic/shared.js";

interface UseCreateNewDefaultProjectOptions {
  throwError?: boolean;
  routingMode?: "replace" | "push";
}

export function useCreateNewDefaultExplore({
  routingMode = "push",
  throwError,
}: UseCreateNewDefaultProjectOptions = {}) {
  const history = useHistory();
  const [createExplore] = useCreateExploreMutation();
  const createNewExplore = useCallback(
    async (newTab?: boolean) => {
      try {
        const { data } = await createExplore({
          variables: {
            additionalFilters: [],
            name: DEFAULT_PROJECT_TITLE,
            projectLanguage: null,
            baseCellId: null,
            sourceAppSessionId: null,
          },
        });
        if (data?.createExplore?.id == null) {
          throw new Error("Creation failed");
        }
        const exploreViewArgs: ExploreRouteParams = {
          hexLocator: hexIdToHumanHexId(
            data.createExplore.id,
            DEFAULT_PROJECT_TITLE,
          ),
        };
        if (newTab) {
          window.open(
            Routes.EXPLORE.href(ORG_ID, true, exploreViewArgs),
            "_blank",
          );
        } else {
          Routes.EXPLORE[routingMode](history, exploreViewArgs);
        }
      } catch (e) {
        console.error(e);
        if (throwError) {
          throw e;
        }
      }
    },
    [createExplore, routingMode, history, throwError],
  );

  return createNewExplore;
}
